import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import ErrorPanel from '../components/UIKit1/errorPanel/errorPanel';
export var StyleError = /*#__PURE__*/function (_Error) {
  function StyleError(_ref) {
    var _this;
    var issue = _ref.issue,
      message = _ref.message;
    _classCallCheck(this, StyleError);
    _this = _callSuper(this, StyleError, [message]);
    _this._issue = issue;
    _this._property = '';
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(_this, StyleError.prototype);
    return _this;
  }
  _inherits(StyleError, _Error);
  return _createClass(StyleError, [{
    key: "issue",
    get: function get() {
      return this._issue;
    }
  }, {
    key: "property",
    get: function get() {
      return this._property;
    },
    set: function set(value) {
      this._property = value;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var StyleErrorBoundary = /*#__PURE__*/function (_Component) {
  function StyleErrorBoundary() {
    var _this2;
    _classCallCheck(this, StyleErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, StyleErrorBoundary, [].concat(args));
    _defineProperty(_this2, "state", {
      error: null
    });
    return _this2;
  }
  _inherits(StyleErrorBoundary, _Component);
  return _createClass(StyleErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      if (!(error instanceof StyleError)) {
        throw error;
      }
      this.setState({
        error: error
      });
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;
      if (!error) {
        return this.props.children;
      }
      return /*#__PURE__*/React.createElement(ErrorPanel, {
        error: {
          name: 'style-error',
          message: "Error was thrown on style property: ".concat(error.property),
          errorMessage: "".concat(error.issue, "\n").concat(error.message)
        },
        isReloadPage: true
      });
    }
  }]);
}(Component);
export default StyleErrorBoundary;